import { render, staticRenderFns } from "./github.vue?vue&type=template&id=461a89ec&scoped=true&"
import script from "./github.vue?vue&type=script&lang=ts&"
export * from "./github.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a89ec",
  null
  
)

export default component.exports